<template>
  <div>
    <report-header @generate="load" @filterChanged="filterChanged"
      @onChangedDateStart="onChangedDateStart" @onChangedDateEnd="onChangedDateEnd" @onChangedGroup="onChangedGroup"
      :filterOptions="filterOptions" :isGenerateDisabled="isGenerateDisabled" @paginationChanged="paginationChanged"/>
    <b-table striped hover small responsive id="tablereport"
      :items="general"
      :fields="generalFields"
      :filter="filter"
      :per-page="perPage"
      :current-page="currentPage"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
  </div>
</template>

<script>
export default {
  props: {
    userId: 0
  },
  data () {
    return {
      getStore: {
        numDateEnd: 0,
        numDateStart: 0,
        userId: 0,
        group_id: 0,
        account_id: 0,
        accounting_period_id: 0
      },
      general: [],
      generalFields: [
        {key: 'account_id', label: this.$i18n.t('Account ID'), sortable: true},
        {key: 'login', label: this.$i18n.t('Login'), sortable: true},
        {key: 'full_name', label: this.$i18n.t('FullName'), sortable: true},
        {key: 'incoming_rest', label: this.$i18n.t('Initial balance'), sortable: true},
        {key: 'once', label: this.$i18n.t('One-time services'), sortable: true},
        {key: 'periodic', label: this.$i18n.t('Periodic services'), sortable: true},
        {key: 'ip_traffic', label: this.$i18n.t('IP traffic'), sortable: true},
        {key: 'hotspot', label: this.$i18n.t('Hotspot services charges'), sortable: true},
        {key: 'dialup', label: this.$i18n.t('Dial-up service charges'), sortable: true},
        {key: 'telephony', label: this.$i18n.t('IP telephony'), sortable: true},
        {key: 'iptv', label: this.$i18n.t('IPTV service charges'), sortable: true},
        {key: 'vod', label: this.$i18n.t('VOD service charges'), sortable: true},
        {key: 'other', label: this.$i18n.t('Other charges report'), sortable: true},
        {key: 'tax', label: this.$i18n.t('Tax sum'), sortable: true},
        {key: 'sum_with_tax', label: this.$i18n.t('Total (incl. taxes)'), sortable: true},
        {key: 'payments', label: this.$i18n.t('Payments'), sortable: true},
        {key: 'outgoing_rest', label: this.$i18n.t('Closing balance'), sortable: true}
      ],
      isGenerateDisabled: false,
      selectGroup: 0,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      dateStart: new Date(),
      dateEnd: new Date(),
      filterOptions: {
        isFilterGroup: true,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: false
      }
    }
  },
  methods: {
    async load () {
      this.isGenerateDisabled = true
      let numDateEnd = Number(this.dateEnd) / 1000
      if (numDateEnd > 2147483647) numDateEnd = 2147483647
      let numDateStart = Number(this.dateStart) / 1000
      if (numDateStart > 2147483647) numDateStart = 2147483647
      this.getStore.numDateEnd = numDateEnd
      this.getStore.numDateStart = numDateStart

      if (!this.userId) {
        this.getStore.group_id = this.selectGroup
      } else {
        this.getStore.userId = this.userId
      }
      await this.$store.dispatch('Reports/GET_GENERAL', this.getStore).then(response => {
        this.general = this.$store.getters['Reports/GENERAL']
        this.loadDone()
      })
      this.totalRows = this.general.length
      this.$emit('input', this.totalRows)
    },
    onChangedDateStart (value) {
      this.dateStart = value
    },
    onChangedDateEnd (value) {
      this.dateEnd = value
    },
    onChangedGroup (value) {
      this.selectGroup = (value)
    },
    filterChanged (value) {
      this.filter = value
    },
    loadDone () {
      this.isGenerateDisabled = false
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  mounted () {
    this.loadDone()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reports/services/general/main.vue